import { render, staticRenderFns } from "./PMDashboardDropdownSelector.vue?vue&type=template&id=8a1968c2&scoped=true&"
import script from "./PMDashboardDropdownSelector.vue?vue&type=script&lang=js&"
export * from "./PMDashboardDropdownSelector.vue?vue&type=script&lang=js&"
import style0 from "./PMDashboardDropdownSelector.vue?vue&type=style&index=0&id=8a1968c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1968c2",
  null
  
)

export default component.exports